import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(({ typography }) => ({
  subHeading: {
    fontFamily: typography.fontFamilySecondary,
    fontSize: '14px',
  },
  subHeading2: {
    fontFamily: typography.fontFamilySecondary,
    fontSize: '12px',
    fontWeight: typography.fontWeightSemiBold,
    marginTop: '2.4em',
    marginBottom: '0.2em',
  },
  infoIcon: {
    marginTop: '4px',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '30px 0px 0px 0px',
    height: 'calc(100vh - 115px)',
  },
  wireTransferContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '30px 0px 0px 0px',
    height: 'auto',
  },
  drawdownDetailTable: {
    padding: '10px 20px 0px 20px',
    background: '#f7f7f7',
    borderRadius: '10px',

    '& .MuiTableBody-root tr': {
      borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
    },
    '& .MuiTableBody-root tr:last-child': {
      borderBottom: 'none',
    },
  },
  drawdownFundingTable: {
    padding: '10px 20px 0px 20px',
    background: '#f7f7f7',
    borderRadius: '10px',
    marginTop: '12px',
  },
  wireTransferGuide: {
    marginTop: '12px',
    paddingBottom: '20px',
  },
  accountDetailTable: {
    background: 'transparent',
    padding: '10px 20px 0px 20px',
    marginTop: '12px',
    borderRadius: '10px',
    '& .MuiTableBody-root tr': {
      borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
    },
    '& .MuiTableBody-root tr td': {
      padding: '8px 0px !important',
    },
    '& .MuiTableBody-root tr:last-child': {
      borderBottom: 'none',
    },
  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    marginTop: 'auto',
  },
}), { name: 'DrawdownConfirmationStyles' });

export default useStyles;
